<nav
  #menuViewport
  class="menu-tabs-viewport"
  (scroll)="updateScrollEdges(menuViewport)"
  [attr.aria-label]="'MENU_TABS.ARIA_LABEL' | translate">
  <div
    #menuTrack
    class="menu-tabs-list">
    @for (tab of tabs(); track tab.context) {
      <a
        #menuItem
        class="menu-tabs-item"
        (focus)="revealMenuItem(menuItem)"
        [class.menu-tabs-item_active]="tab.context === activeContext()"
        [attr.aria-current]="tab.context === activeContext() ? 'page' : null"
        [attr.aria-label]="badges()[tab.context]?.ariaLabel ?? null"
        [appFocusTarget]="'bottom-context-' + tab.context"
        [routerLink]="tab.route">
        <span class="menu-tabs-item-icon">
          <svg
            aria-hidden="true"
            [lucideIcon]="tab.icon"
            [size]="24"></svg>
          @if (badges()[tab.context]; as badge) {
            <span
              class="menu-tabs-item-chat-badge"
              [class.muted]="badge.muted"
              aria-hidden="true">
              <span class="menu-tabs-item-chat-badge-label">
                {{ badge.label }}
              </span>
            </span>
          }
        </span>
        <span class="menu-tabs-item-text">
          {{ tab.labelKey | translate }}
        </span>
      </a>
    }
  </div>
</nav>

<span
  class="menu-tabs-edge menu-tabs-edge_start"
  [class.menu-tabs-edge_visible]="canScrollToStart()"
  aria-hidden="true">
</span>
<span
  class="menu-tabs-edge menu-tabs-edge_end"
  [class.menu-tabs-edge_visible]="canScrollToEnd()"
  aria-hidden="true">
</span>
